import { Link } from 'react-router-dom'
import { t, type Lang } from '../lib/i18n'

interface EmptyStateProps {
  lang: Lang
}

export function EmptyState({ lang }: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-border bg-bg-subtle p-10 text-center">
      <div className="mb-3 text-3xl leading-none">📭</div>
      <h2 className="text-base font-semibold text-text">{t(lang, 'requests.empty.title')}</h2>
      <p className="mt-2 text-sm text-text-muted">{t(lang, 'requests.empty.body')}</p>
      <Link
        to={`/request?lang=${lang}`}
        className="mt-5 inline-block rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover"
      >
        {t(lang, 'requests.empty.cta')} →
      </Link>
    </div>
  )
}
